module.exports = __webpack_public_path__ + "static/media/map-kor.139e3022.jpg";